import {
  getFemaleConsumptionRisk,
  getMaleConsumptionRisk
} from "drinkaware-tools-api-library";

import { Gender, GenderIndexer } from "@dcc/types/gender";
import { roundToNDecimalPlaces } from "@dcc/common/rounding";
import { RiskLevel } from "@dcc/types/riskLevel";
import { dataApi } from "@dcc/api";
import { ConsumptionRiskResponse } from "drinkaware-tools-api-library/dist/src/clients/data/src/models";

export type ConsumptionRiskIndexer = GenderIndexer<ConsumptionRiskResponse>;

export const consumptionRisk: ConsumptionRiskIndexer = {
  [Gender.Male]: {
    consumption: []
  },
  [Gender.Female]: {
    consumption: []
  }
};

export const getConsumptionRiskDataForGender = (gender: Gender) => {
  return consumptionRisk[gender];
};

export const getDiseaseRiskConsumptionValue = ({
  gender,
  weeklyUnits,
  noDrinkingDays
}: {
  gender: Gender;
  weeklyUnits: number;
  noDrinkingDays: number;
}) => {
  if (noDrinkingDays < 0 || noDrinkingDays > 7) {
    return undefined;
  }

  const { consumption } = getConsumptionRiskDataForGender(gender);

  if (!consumption) {
    return undefined;
  }
  let findEntry = consumption.find(
    (entry) => entry.unitsPerWeek >= weeklyUnits
  );
  if (!findEntry) {
    findEntry = consumption[consumption.length - 1];
  }
  return findEntry ? findEntry[`day${noDrinkingDays}` as "day1"] : undefined;
};

export const getDiseaseRisk = ({
  riskLevel,
  gender,
  weeklyUnits,
  noDrinkingDays
}: {
  riskLevel: RiskLevel;
  gender: Gender;
  weeklyUnits: number;
  noDrinkingDays: number;
}) => {
  if (riskLevel === RiskLevel.Low) {
    return 0;
  }
  const diseaseRiskConsumptionValue = getDiseaseRiskConsumptionValue({
    gender,
    weeklyUnits,
    noDrinkingDays
  });
  return diseaseRiskConsumptionValue
    ? roundToNDecimalPlaces((1 / diseaseRiskConsumptionValue) * 100, 0)
    : undefined;
};

export const fetchFemaleConsumptionRisk = async () => {
  try {
    consumptionRisk[Gender.Female] = await getFemaleConsumptionRisk({
      data: dataApi
    });
  } catch {
    // eslint-disable-next-line
    console.log("An error has occurred");
  }
};

export const fetchMaleConsumptionRisk = async () => {
  try {
    consumptionRisk[Gender.Male] = await getMaleConsumptionRisk({
      data: dataApi
    });
  } catch {
    // eslint-disable-next-line
    console.log("An error has occurred");
  }
};
